module.exports = __webpack_public_path__ + "media/images/payid-logo-9ac56248a8f60f26e50483d729b6776d.png";